function getNormalizedPermissions(): string[] {
  try {
    const stored = sessionStorage.getItem("Permissions");
    if (!stored) return [];

    const parsed = JSON.parse(stored);

    if (Array.isArray(parsed)) {
      return parsed
        .filter(
          (p) =>
            p &&
            typeof p.moduleName === "string" &&
            typeof p.actionName === "string"
        )
        .map((p) => `${p.moduleName}:${p.actionName}`.toLowerCase());
    }

    console.warn("Unexpected permissions format:", parsed);
    return [];
  } catch (error) {
    console.error("Error parsing Permissions from sessionStorage:", error);
    return [];
  }
}

export function hasModulePermission(moduleName: string): boolean {
  const permissions = getNormalizedPermissions();
  return permissions.some((perm) =>
    perm.startsWith(`${moduleName.toLowerCase()}:`)
  );
}

export function hasMainMenuPermission(moduleNames: string[]): boolean {
  const permissions = getNormalizedPermissions();
  const ok = moduleNames.some((name) =>
    permissions.some((perm) => perm.startsWith(`${name.toLowerCase()}:`))
  );
  return ok;
}

export function hasModuleActionPermission(
  moduleName: string,
  actionName: string
): boolean {
  const permissions = getNormalizedPermissions();
  const key = `${moduleName}:${actionName}`.toLowerCase();
  return permissions.includes(key);
}
